import { useEffect, useState } from 'react'
import {
  faCss3,
  faGitAlt,
  faHtml5,
  faJsSquare,
  faReact,
} from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.scss'
import { Link } from 'react-router-dom'

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['A', 'b', 'o', 'u', 't', ' ', 'M', 'e']}
              idx={15}
            />
          </h1>
          <p>
            I am an experienced front-end developer looking for projects or part time opportunities. With over 10 years experience in Web Development I specialize in HTML5, CSS3, JavaScript and now React. I am also familiar with many different Content Management Systems such as Oracle Webcenter, Teamsite, AEM, Wordpress and many more. Currently taking an advanced React course so lookout for more. 
          </p>
          <p align="LEFT">
            I enjoy building and trouble shooting solutions as well as learning new technologies. The team concept is something I like to be a part of and I can also work independently. 
          </p>
          <p>
            If you have any questions or just want to reach out to say hi, feel free to fill out my <Link to="/contact" className="flat-button">Contact Form</Link> . Thanks for visiting my site. 
          </p>
        </div>

        <div className="stage-cube-cont">
          <div className="cubespinner">
            {/*<div className="face1">
              <FontAwesomeIcon icon={faAngular} color="#DD0031" />
            </div>*/}
            <div className="face1">
              <FontAwesomeIcon icon={faHtml5} color="#F06529" />
            </div>
            <div className="face2">
              <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
            </div>
            <div className="face3">
              <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
            </div>
            <div className="face4">
              <FontAwesomeIcon icon={faHtml5} color="#F06529" />
            </div>
            <div className="face5">
              <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
            </div>
            <div className="face6">
              <FontAwesomeIcon icon={faGitAlt} color="#EC4D28" />
            </div>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About
